import styled, { css } from 'styled-components';

const TagSelectButton = styled.div`
  height: 100%;
  min-height: 40px;
`;

const TagWrapper = styled.div`
  ${({ isFocused, readOnly }) => {
    return css`
      ${!readOnly &&
      css`
        margin-left: -16px;
      `}
      ${!isFocused &&
      css`
        ${TagSelectButton} {
          align-items: center;
          display: flex;
          gap: 4px;

          ${!readOnly &&
          css`
            cursor: pointer;
            padding: 4px 16px;

            &:hover {
              border-radius: var(--size-border-radius-md);
              outline: 1px solid var(--color-border-default);
            }
          }
        `}
        }
      `}
    `;
  }}

  border-radius: var(--size-border-radius-md);
  width: 100%;
`;

const MoreText = styled.div`
  color: var(--color-components-button-secondary-link-fg);
  margin-left: 4px;
`;

const Placeholder = styled.div`
  color: var(--color-components-button-secondary-link-fg);
`;

const ColumnInputWrapper = styled.div`
  overflow: visible;
  position: relative;
`;

const ColumnInputErrorWrapper = styled.div`
  align-items: center;
  background-color: var(--color-bg-default);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  display: flex;
  gap: var(--size-4);
  left: 0;
  margin-top: 2px;
  padding: var(--size-4);
  position: absolute;
  top: 2px;
  width: 100%;
  z-index: 1;
`;

export {
  ColumnInputErrorWrapper,
  ColumnInputWrapper,
  MoreText,
  Placeholder,
  TagSelectButton,
  TagWrapper
};
